<template>
  <div>
    <label for="basemap-select small" class="font-weight-bold">Basemap</label>
    <b-form-select
      id="basemap-select"
      v-model="selectedBasemap"
      @change="BASEMAP_SET_ACTIVE"
      class="form-control d-block"
      size="sm"
    >
      <option v-for="bm in BASEMAP_LIST" :key="bm.id" :value="bm.id">
        {{ bm.name }}
      </option>
    </b-form-select>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "BasemapSwitcher",
  computed: {
    ...mapState({
      BASEMAP_LIST: (state) => state.map.BASEMAP_LIST,
      BASEMAP_ACTIVE_ID: (state) => state.map.BASEMAP_ACTIVE_ID,
    }),
    selectedBasemap: {
      get() {
        return this.BASEMAP_ACTIVE_ID;
      },
      set(val) {
        this.BASEMAP_SET_ACTIVE(val);
      },
    },
  },
  methods: {
    ...mapMutations({
      BASEMAP_SET_ACTIVE: "map/BASEMAP_SET_ACTIVE",
    }),
  },
};
</script>
